import RichText_1 from "./RichText_1";
export const RichText = {
    "RichText_1": RichText_1
}